import { isMobileOnly } from 'react-device-detect'
import styled, { css } from 'styled-components'

import {
    AbsolutePositioning,
    FlexCentered,
    RowFlex,
    ColumnFlex,
    FullWidthHeight,
} from 'components/common/genericStyles'
import { Color } from 'constants/color'

import { ReactionWrapperBase } from '../styles'

export const Wrapper = styled.div`
    position: relative;
    border-radius: 50%;
    height: max-content;
    ${FullWidthHeight}
    transition: all 1s cubic-bezier(0.65, 0.17, 0.43, 0.99);
    z-index: 0;
    ${props =>
        props.isLocal && !isMobileOnly
            ? css`
                  /* small devices (tabs, 768px and up) */
                  @media only screen and (min-width: 768px) and (orientation: landscape) {
                      &:hover .gesture {
                          display: block;
                      }
                  }
              `
            : ``}

    ${({ isVideoEnabled }) =>
        isVideoEnabled
            ? css`
                  &:hover ${NameChipContainer} {
                      display: flex;
                  }
              `
            : css`
                  ${NameChipContainer} {
                      display: flex;
                  }
              `}
`
export const RectangleOuter = styled.div`
    ${FlexCentered};
    ${ColumnFlex};
    ${FullWidthHeight}
    border-radius: 50%;
`

export const RectangleInner = styled.div`
    border-radius: 50%;
    ${props =>
        props.isAway &&
        css`
            &:not(:hover) div.elsewhere,
            & .avater-container,
            & .video-container {
                -webkit-filter: grayscale(1);
                -moz-filter: grayscale(1);
                -ms-filter: grayscale(1);
                filter: grayscale(1);
            }

            &:not(:hover) div.elsewhere span {
                display: none;
            }

            &:not(:hover) div.elsewhere:after {
                display: block;
            }
        `}

    box-shadow: none;
    position: relative;

    ${FullWidthHeight}
`

export const GestureContainer = styled.div`
    ${AbsolutePositioning};
    margin: 8px;
    border-radius: 50%;
`
export const TileWrapper = styled.div`
    ${FullWidthHeight}
    border-radius: 50%;
    position: absolute;
    z-index: 15;

    ${props =>
        props.isSpeaking &&
        css`
            border: 3px solid ${Color.unknownColor18};
        `}
    padding: 4px;
    box-sizing: border-box;

    ${props =>
        props.isQuizMode
            ? props.isSpeaking
                ? `box-shadow: 4px 4px 0px rgba(0, 0, 0, 0.75)`
                : `filter: drop-shadow(4px 4px 0px rgba(0, 0, 0, 0.75));`
            : null}
`

export const Indicators = styled.div`
    display: flex;
    justify-content: space-between;
    position: absolute;
    right: 7%;
    top: 11%;
    z-index: 20;
    /* handheld devices (ipads, phones, 992px and down) */
    @media only screen and (max-width: 992px) {
        justify-content: center;
        width: 85%;
        top: 80%;
    }
`
export const Indicator = styled.img`
    border-radius: 50%;
    width: 15%;
    /* Extra small devices (phones, 600px and down) */
    @media only screen and (max-width: 600px) {
        width: 20%;
    }
`

export const NameChipContainer = styled.div`
    ${FlexCentered};
    ${RowFlex};
    position: absolute;
    bottom: -0.3%;
    z-index: 17;
    width: 100%;
    display: none;
`

export const NameChipContainerMobile = styled(NameChipContainer)`
    bottom: -6%;
    display: flex;
    @media only screen and (orientation: landscape) {
        bottom: 7%;
    }
`

const IndicatorIcon = styled.div`
    display: flex;
    position: absolute;
    width: 12%;
    height: 12%;
    max-width: 45px;
    max-height: 45px;
    z-index: 15;
`

export const ScreenShareIndicator = styled(IndicatorIcon)`
    background-image: url(/assets/revamp/screenshare-on.svg);
    background-repeat: no-repeat;
    background-position: center;
    background-color: #000;
    background-size: 70%;
    border-radius: 50%;
    top: 35%;
    left: 0%;
`

export const AudioIndicatorContainer = styled(IndicatorIcon)`
    top: 11%;
    left: 11%;
`

export const NetworkIndicatorContainer = styled(IndicatorIcon)`
    top: 21%;
    left: 1%;
`

export const ReactionWrapper = styled(ReactionWrapperBase)`
    z-index: 15;
    border-radius: 50%;
`
